import React from "react";
import InvoiceEditor from "@/pages/sales/InvoiceEditor";
export default function Purchases() { return <InvoiceEditor kind="purchase" />; }
